module.exports = __webpack_public_path__ + "static/media/frozen-root-beer-mb-fr.4ef2b946.mp4";